import request from "./axiosConfig";
// 获取院校列表
export const getSchools = () => {
  return request({
    url: "/interface/school/alllist",
    method: "get",
  });
};
/**
 * 获取学校详情
 * @param {number} id - 学校ID
 */
export function getSchoolDetail(id) {
  return request({
    url: `/interface/school/schooldetail`,
    method: "get",
    params: { id },
  });
}
// 获取学校招生信息
export function getSchoolStudentInfo(id) {
  return request({
    url: `/interface/school/schoolstudent`,
    method: "get",
    params: { id },
  });
}

// 获取所有学校及学校包含的专业列表
export const getAllSchoolsWithMajors = () => {
  return request({
    url: "/interface/school/allwithmajors",
    method: "get",
  });
};

// 获取各省市招生计划列表
export const getEnrolmentPlans = (params) => {
  return request({
    url: "/interface/enrolmentplans/list",
    method: "get",
    params,
  });
};
